import React from 'react'
import { bool, string } from 'prop-types'
import { Button } from '@livechat/design-system-react-components'

import { useTypedDispatch, useTypedSelector } from '@/store/hooks'
import { getPublishedApp, isAppInReview } from '@/store/selectors'
import { getProductApplicationsPath } from '@/utils/products'
import { pushGenericEvent } from '@/utils/analytics'
import useParamSelector from '@/hooks/useParamSelector'
import { logAmplitudeEvent } from '@/store/stats'
import { navigateToIFrame } from '@/utils'
import { AMPLITUDE_EVENTS } from '@/constants'

export const SettingsButton = ({ className, fullWidth, size, id }) => {
  const dispatch = useTypedDispatch()
  const product = useTypedSelector((state) => getPublishedApp(state, id))
  const isInReview = useParamSelector(isAppInReview, id)
  const { slug = id, product: productType, name } = product

  const handleOpenSettings = (e) => {
    pushGenericEvent({
      action: 'Settings',
      label: id,
    })
    dispatch(
      logAmplitudeEvent({
        name: AMPLITUDE_EVENTS.SETTINGS_CLICKED,
        params: {
          appId: id,
          appName: name,
        },
      })
    )
    navigateToIFrame(
      e,
      `${getProductApplicationsPath(productType)}/${isInReview ? id : slug}`,
      productType
    )
  }

  return (
    <Button
      kind="secondary"
      size={size}
      className={className}
      fullWidth={fullWidth}
      onClick={handleOpenSettings}
    >
      Settings
    </Button>
  )
}

SettingsButton.propTypes = {
  className: string,
  fullWidth: bool,
  size: string,
  id: string,
}

export default SettingsButton
